import { generaArrayDateNuovoFinoAl, formatDataPerTasto } from "./parametriImportFornitore";
import useArticleImportRequest from "../useArticleImportRequest";
import React, { useState } from "react";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function TracciatoFornitore({ nomeFornitore, titoloPagina, utente }) {
  const uploadArticleCsv = useArticleImportRequest(utente);
  const datePapabiliPerNuovoFinoAl = generaArrayDateNuovoFinoAl();

  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [risultatoOperazione, setRisultatoOperazione] = useState(
    "In attesa dell'upload"
  );
  const [risultato, setRisultato] = useState(null);
  const [input, setInput] = useState({
    idStagioneCollezionePSatt: null,
    idStagioneCollezionePSabb: null,
    idStagioneConsigliataPS: null,
    nuovoFinoAl: datePapabiliPerNuovoFinoAl[0],
  });
  const [test, setTest] = useState(true);

  const {
    inputClassesConTasto,
    classiTastoSblocco,
    tastoCopiaAspetto,
    buttonClassesWhite,
  } = stilePulsanti;

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
      setInput({
        ...input,
        [evt.target.name]: value,
      });
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const handleSubmission = () => {
    const formData = new FormData();

    formData.append("uploaded_file", selectedFile);
    const parametri = new URLSearchParams({
      nomeFornitore: nomeFornitore,
      idStagioneCollezionePSatt: input.idStagioneCollezionePSatt,
      idStagioneCollezionePSabb: input.idStagioneCollezionePSabb,
      idStagioneConsigliataPS: input.idStagioneConsigliataPS,
      nuovoFinoAl: input.nuovoFinoAl,
      test: test,
    });

    uploadArticleCsv(apiUrl + "/csv/tracciati/universale?" + parametri, formData)
      .then((result) => {
        setRisultato(result);
        setRisultatoOperazione("Dati caricati correttamente");
        console.log("Success:", result);
      })
      .catch((error) => {
        setRisultatoOperazione(error.message);
        console.error("Error:", error);
      });
  };

  return (
    <div className="flex">
      <div className="w-30 fr pl4 pr4 ">
        <div className="f3 b mt3 mb4">{titoloPagina}</div>
        <div className="f4 mt3 mb3">
          Id della stagione collezione, (se necessario crea la nuova stagione su
          prestashop prima):
        </div>
        <label className="mr1" for="idStagioneCollezionePSatt">
          Per l'attrezzatura (Inverno...)
        </label>
        <input
          type="number"
          name="idStagioneCollezionePSatt"
          onChange={handleChange}
          value={input.idStagioneCollezionePSatt}
          className="input-reset inputOrizzontale"
        ></input>
        <label className="mr1" for="idStagioneCollezionePSabb">
          Per il resto (Autunno/Inverno...)
        </label>
        <input
          type="number"
          name="idStagioneCollezionePSabb"
          onChange={handleChange}
          value={input.idStagioneCollezionePSabb}
          className="input-reset inputOrizzontale"
        ></input>
        <div className="f4 mt3 mb3">Id della stagione consigliata:</div>
        <input
          type="number"
          name="idStagioneConsigliataPS"
          onChange={handleChange}
          value={input.idStagioneConsigliataPS}
          className="input-reset inputOrizzontale"
        ></input>
        <div className="f4 mt3 mb3">Nuovo fino al:</div>
        {datePapabiliPerNuovoFinoAl.map((tasto, i) => {
          return (
            <button
              id={"nuovoFinoAl"}
              name={"nuovoFinoAl"}
              value={tasto}
              onClick={handleChange}
              className="tastoBianco f6-ns link dim ba ph3 pv2 dib br3 bordoColAlt mr2 pointer"
            >
              {formatDataPerTasto(tasto)}
            </button>
          );
        })}

        <br />
        <br />
        <br />
        <br />
        <input type="file" accept="csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div>
            <p>Nome del file: {selectedFile.name}</p>
            <p>Tipo file: {selectedFile.type}</p>
            <p>Dimensione in bytes: {selectedFile.size}</p>
            <p>
              Data ultima modifica:{" "}
              {selectedFile.lastModifiedDate.toLocaleDateString()}
            </p>
          </div>
        ) : (
          <p>Seleziona un file</p>
        )}
        <div>
          <button
            onClick={handleSubmission}
            className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center"
          >
            Carica
          </button>
        </div>
        <form className="pa3">
          <input
            type="checkbox"
            id="opt-in-checkbox"
            checked={test}
            onChange={(event) => {
              setTest(event.target.checked);
            }}
          />
          <label htmlFor="opt-in-checkbox" className="pl2">
            Test
          </label>
        </form>
        <p>{risultatoOperazione}</p>
      </div>
      <div className="w-70 fr sezioneConScroll colonna90vh">
        {!risultato && (
          <pre className="w-100">{JSON.stringify(input, null, 2)}</pre>
        )}
        {risultato && (
          <pre className="w-100">{JSON.stringify(risultato, null, 2)}</pre>
        )}
      </div>
    </div>
  );
}

export default TracciatoFornitore;
